// import SwaggerUI from "swagger-ui-react"
// import "swagger-ui-react/swagger-ui.css";
//        <SwaggerUI url="https://approval.aws.stag.visma.net/apidocs/specs/support-api.json"/>

export const Swagger = () => {

    return <div className="swagger-container w-100 overflow-x-auto">

    </div>
};


export default Swagger;